(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/filter-and-sort/assets/javascripts/components/filter-section.js') >= 0) return;  svs.modules.push('/components/casino-react/filter-and-sort/assets/javascripts/components/filter-section.js');

'use strict';

const {
  useMemo
} = React;
const {
  useSearchParams
} = svs.components.casino_react.hooks;
const {
  FilterOption
} = svs.components.casino_react.filterAndSort.components;
const {
  AccordionItem,
  AccordionSummary,
  AccordionDetails
} = svs.ui.ReactAccordion;
const {
  ReactBadge: Badge
} = svs.ui;
const FilterSection = _ref => {
  let {
    filterSection
  } = _ref;
  const searchParams = useSearchParams();
  const activeSectionFilters = useMemo(() => searchParams[filterSection.type], [searchParams, filterSection.type]);
  return React.createElement(AccordionItem, {
    isFlat: true
  }, React.createElement(AccordionSummary, null, filterSection.title, activeSectionFilters.length > 0 && React.createElement(Badge, {
    bounce: true,
    className: "casino-filter-and-sort__filter-section-badge badge-casino",
    size: "small"
  }, activeSectionFilters.length)), React.createElement(AccordionDetails, null, React.createElement("ul", {
    className: "filter-list"
  }, filterSection.options.map(filterOption => React.createElement(FilterOption, {
    checked: activeSectionFilters.includes(filterOption.title),
    filterOption: filterOption,
    filterType: filterSection.type,
    key: filterOption.title
  })))));
};
setGlobal('svs.components.casino_react.filterAndSort.components.FilterSection', FilterSection);

 })(window);